
import { defineComponent } from "vue";
import MindGamesHeader from "@/components/MindGamesHeader.vue";

export default defineComponent({
  name: "SiteWrapper",

  components: {
    MindGamesHeader,
  },

  created() {
    this.$store.dispatch("getTheme");
  },

  computed: {
    isHome() {
      return this.$route.name === "Home";
    },
    theme() {
      return this.$store.state.theme;
    },
    themeClass(): string {
      return `theme--${this.theme}`;
    },
  },
});
